module.exports = __webpack_public_path__ + "img/lifestyle-style-expert.4c17f40e.svg";